export default __webpack_public_path__ + "static/media/directory.41c628a2.jpg";